import { config } from "../config";
import type { Health, Market, Quote } from "../types";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${config.apiUrl}${path}`, init);
  const body = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? `API returned ${response.status}`);
  return body;
}

export async function getHealth(): Promise<Health> {
  return request<Health>("/v1/health");
}

export async function getMarkets(): Promise<Market[]> {
  const result = await request<{ markets: Market[] }>("/v1/markets?offset=0&limit=100");
  return result.markets;
}

export async function getQuote(
  marketId: string,
  side: "SHORT" | "LONG",
  direction: "BUY" | "SELL",
  collateralAmount: bigint
): Promise<Quote> {
  const query = new URLSearchParams({
    marketId,
    side,
    direction,
    collateralAmount: collateralAmount.toString()
  });
  return (await request<{ quote: Quote }>(`/v1/quote?${query}`)).quote;
}

export interface OracleSpecInput {
  version: 1;
  source: "hyperliquid";
  metric: "funding" | "volatility";
  coin: string;
  startTime: number;
  endTime: number;
  interval: "1m" | "5m" | "15m" | "1h" | "4h" | "1d";
  aggregation: "arithmetic-mean" | "root-mean-square-log-returns";
  scale: "1000000000000";
}

export async function storeMetadata(spec: OracleSpecInput): Promise<{
  descriptorHash: `0x${string}`;
  metadataURI: string;
}> {
  return request("/v1/metadata", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(spec)
  });
}
